import React from 'react';

import app from 'components/app';
import LawyerDocument from 'components/LawyerDocument';
import Page from 'components/Page';
import Section from 'components/Page/Section';
import Wrapper from 'components/Page/Wrapper';
import { useTranslation } from 'lib/i18n';

import cs from './cs.html';
import en from './en.html';

const html = { cs, en, sk: cs };

const Terms: React.FC = () => {
  const { t, i18n } = useTranslation('pages');
  return (
    <Page title={t('terms.title')} footer noPadding>
      <Section white>
        <Wrapper>
          <LawyerDocument
            html={
              html[(i18n.language as 'cs' | 'en', 'sk')] ||
              html[(DEFAULT_LOCALE as 'cs' | 'en', 'sk')]
            }
          />
        </Wrapper>
      </Section>
    </Page>
  );
};

export default app(Terms);
